query getActiveAutomaticPayoutConfig {
  automaticPayoutConfigs(where: { active: { equalTo: true } }, first: 1, order: createdAt_DESC) {
    edges {
      node {
        objectId
      }
    }
  }
}
